import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActionCommandService, ActionCommand } from '../../../services/action-command.service';
import { MenuStateService } from '../../../services/menu-state.service';
import { OpenShiftWorkComponent } from './open-shift-work/open-shift-work.component';
import { CloseShiftWorkComponent } from './close-shift-work/close-shift-work.component';
import { CreditoComponent } from './credito/credito.component';
import { WithdrawalComponent } from './withdrawal/withdrawal.component';
import { WithdrawalListComponent } from './withdrawal-list/withdrawal-list.component';
import { SupplyComponent } from './supply/supply.component';
import { CashClosureComponent } from './cash-closure/cash-closure.component';

@Component({
  selector: 'app-admin-menu',
  imports: [
    CommonModule,
    FormsModule,
    OpenShiftWorkComponent,
    CloseShiftWorkComponent,
    CreditoComponent,
    WithdrawalComponent,
    WithdrawalListComponent,
    SupplyComponent,
    CashClosureComponent
  ],
  templateUrl: './admin-menu.component.html'
})
export class AdminMenuComponent implements OnInit, OnDestroy {

  selectedMenu = '';

  constructor(
    private actionCommandService: ActionCommandService,
    private menuStateService: MenuStateService
  ) {}

  // Verificar se há turno aberto
  get hasOpenShift(): boolean {
    return localStorage.getItem('pdvId') !== null;
  }

  ngOnInit(): void {
    this.registerCommands();
    this.subscribeToMenuState();
  }

  private subscribeToMenuState(): void {
    this.menuStateService.currentSubMenu$.subscribe(subMenu => {
      this.selectedMenu = subMenu;
      // Se voltou para o menu principal, re-registrar comandos após o próximo tick para que
      // o submenu (ex.: withdrawal-list) tenha tempo de desregistrar seu ESC no ngOnDestroy;
      // assim o ESC do menu admin fica ativo e o usuário pode fechar o menu com ESC.
      if (subMenu === '') {
        setTimeout(() => {
          this.unregisterCommands();
          this.registerCommands();
        }, 0);
      }
    });
  }

  private registerCommands(): void {
    // Registrar comando F1 para abrir turno (só se não houver turno aberto)
    if (!this.hasOpenShift) {
      this.actionCommandService.registerCommand({
        getKey: () => 'F1',
        execute: () => this.openShiftWork(),
        getDescription: () => 'Abrir Turno'
      });
    }

    // Registrar comando F2 para fechar turno (só se houver turno aberto)
    if (this.hasOpenShift) {
      this.actionCommandService.registerCommand({
        getKey: () => 'F2',
        execute: () => this.closeShiftWork(),
        getDescription: () => 'Fechar Turno'
      });
    }

    // Registrar comando F3 para vendas
    this.actionCommandService.registerCommand({
      getKey: () => 'F3',
      execute: () => this.openSales(),
      getDescription: () => 'Vendas'
    });

    // Registrar comando F4 para retiradas e suprimentos
    this.actionCommandService.registerCommand({
      getKey: () => 'F4',
      execute: () => this.openRecords(),
      getDescription: () => 'Retiradas e Suprimentos'
    });


    // Registrar comando F5 para fechamento de caixa
    this.actionCommandService.registerCommand({
      getKey: () => 'F5',
      execute: () => this.openClosures(),
      getDescription: () => 'Fechamento de Caixa'
    });

    // Registrar comando F6 para realizar sangria (só se houver turno aberto)
    if (this.hasOpenShift) {
      this.actionCommandService.registerCommand({
        getKey: () => 'F6',
        execute: () => this.openWithdrawal(),
        getDescription: () => 'Realizar Sangria'
      });
    }

    // Registrar comando F9 para realizar suprimento (só se houver turno aberto)
    if (this.hasOpenShift) {
      this.actionCommandService.registerCommand({
        getKey: () => 'F9',
        execute: () => this.openSupply(),
        getDescription: () => 'Realizar Suprimento'
      });
    }

    // Registrar comando F7 para recebimentos
    this.actionCommandService.registerCommand({
      getKey: () => 'F7',
      execute: () => this.openReceipts(),
      getDescription: () => 'Recebimentos'
    });

    // Registrar comando F8 para trocas
    this.actionCommandService.registerCommand({
      getKey: () => 'F8',
      execute: () => this.openExchanges(),
      getDescription: () => 'Trocas'
    });

    // Registrar comando ESC para voltar/fechar
    this.actionCommandService.registerCommand({
      getKey: () => 'ESC',
      execute: () => this.goBack(),
      getDescription: () => 'Voltar/Fechar'
    });
  }

  private unregisterCommands(): void {
    // Desregistrar apenas os comandos que este componente registrou
    this.actionCommandService.unregisterCommand('F1');
    this.actionCommandService.unregisterCommand('F2');
    this.actionCommandService.unregisterCommand('F3');
    this.actionCommandService.unregisterCommand('F4');
    this.actionCommandService.unregisterCommand('F5');
    this.actionCommandService.unregisterCommand('F6');
    this.actionCommandService.unregisterCommand('F9');
    this.actionCommandService.unregisterCommand('F7');
    this.actionCommandService.unregisterCommand('F8');
    this.actionCommandService.unregisterCommand('ESC');
  }

  openShiftWork(): void {
    this.menuStateService.setSubMenu('OPEN_SHIFT');
  }

  closeShiftWork(): void {
    this.menuStateService.setSubMenu('CLOSE_SHIFT');
  }

  openSales(): void {
    console.log('Abrindo vendas');
    // Implementar lógica para abrir vendas
  }


  openRecords(): void {
    // Abrir menu de registros (sangrias)
    this.menuStateService.setSubMenu('WITHDRAWAL_LIST');
  }

  openClosures(): void {
    // Abrir tela de fechamento de caixa
    this.menuStateService.setSubMenu('CASH_CLOSURE');
  }

  openWithdrawal(): void {
    this.menuStateService.setSubMenu('WITHDRAWAL');
  }

  /** Abre a tela de realização de suprimento (F9). */
  openSupply(): void {
    this.menuStateService.setSubMenu('SUPPLY');
  }

  openReceipts(): void {
    console.log('Abrindo recebimentos');
    // Implementar lógica para abrir recebimentos
  }

  openExchanges(): void {
    console.log('Abrindo trocas');
    // Implementar lógica para abrir trocas
  }

  goBack(): void {
    // Se estiver em um submenu, volta para o menu principal
    if (this.selectedMenu !== '') {
      this.menuStateService.goBackToMainMenu();
    } else {
      // Se estiver no menu principal, fecha o menu admin completamente
      // Re-registrar comandos do PDV antes de fechar (via MenuStateService)
      // O PDV irá re-registrar quando receber o evento de fechamento
      this.menuStateService.closeAdminMenu();
    }
  }

  ngOnDestroy(): void {
    // IMPORTANTE: Não desregistrar comandos aqui porque o componente pode ser destruído
    // antes do PDV re-registrar seus comandos. O PDV irá re-registrar quando o menu fecha.
    // this.unregisterCommands(); // Removido para evitar problemas de timing
  }

}
